module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d84cdb7f4b9567882511ab47f63e342b.svg";